import { render, staticRenderFns } from "./Calculation.vue?vue&type=template&id=6d3c6180&scoped=true&"
import script from "./Calculation.vue?vue&type=script&lang=js&"
export * from "./Calculation.vue?vue&type=script&lang=js&"
import style0 from "./Calculation.vue?vue&type=style&index=0&id=6d3c6180&lang=less&scoped=true&"
import style1 from "./Calculation.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c6180",
  null
  
)

export default component.exports